"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = y[op[0] & 2 ? "return" : op[0] ? "throw" : "next"]) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [0, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __values = (this && this.__values) || function (o) {
    var m = typeof Symbol === "function" && o[Symbol.iterator], i = 0;
    if (m) return m.call(o);
    return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
};
Object.defineProperty(exports, "__esModule", { value: true });
var database = require("common/infra/database");
var firebase = require("firebase");
var stateful_items_repository_1 = require("./stateful-items-repository");
var Storage = /** @class */ (function () {
    function Storage() {
        var _this = this;
        this.ref = null;
        this.updateCallbacks = [];
        this.statefulItemsRepository = function (itemsName) {
            return new stateful_items_repository_1.default(itemsName, function (callback) { return _this.updateCallbacks.push(function (updatedItemsName) {
                if (itemsName === updatedItemsName) {
                    callback();
                }
            }); });
        };
    }
    Storage.prototype.initialize = function () {
        var _this = this;
        firebase.auth().onAuthStateChanged(function (user) { return __awaiter(_this, void 0, void 0, function () {
            var _this = this;
            var _loop_1, this_1, _a, _b, callback, e_1, _c;
            return __generator(this, function (_d) {
                if (user === null) {
                    this.ref = null;
                }
                else {
                    this.ref = firebase.database().ref(database.storagePath(user.uid));
                    _loop_1 = function (callback) {
                        this_1.ref.on("child_changed", function () { return __awaiter(_this, void 0, void 0, function () { var _a; return __generator(this, function (_b) {
                            switch (_b.label) {
                                case 0:
                                    _a = callback;
                                    return [4 /*yield*/, this.ref.once("value")];
                                case 1: return [2 /*return*/, _a.apply(void 0, [(_b.sent()).val().updatedItems])];
                            }
                        }); }); });
                    };
                    this_1 = this;
                    try {
                        for (_a = __values(this.updateCallbacks), _b = _a.next(); !_b.done; _b = _a.next()) {
                            callback = _b.value;
                            _loop_1(callback);
                        }
                    }
                    catch (e_1_1) { e_1 = { error: e_1_1 }; }
                    finally {
                        try {
                            if (_b && !_b.done && (_c = _a.return)) _c.call(_a);
                        }
                        finally { if (e_1) throw e_1.error; }
                    }
                }
                return [2 /*return*/];
            });
        }); });
    };
    return Storage;
}());
var storage = new Storage();
exports.default = storage;



//////////////////
// WEBPACK FOOTER
// ./src/infra/storage.ts
// module id = 63
// module chunks = 0